import React, { FC } from 'react';

// Define the type for each option in the select dropdown
interface Option {
  /** label option */
  label: string;
  /** value option */
  value: string | number;
}

// Define the props for the SelectInput component
interface SelectInputProps {
  /** An array of options */
  options: Option[];
  /** The selected value */
  value: string | number | undefined;
  /** Callback for when the selected value changes */
  onChange: (value: string | number) => void;
  /** Additional class name add */
  className?: string
}

const SelectInput: FC<SelectInputProps> = ({ options, value, onChange, className }) => {
  return (
    <select className={className} value={value} onChange={(e) => onChange(e.target.value)}>
      {options.map((option, id: number) => (
        <option key={id} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default SelectInput;